export const breakpoints = {
	sm: 576,
	md: 816,
	lg: 1008,
	xl: 1320,
};
